export const LOAN_TYPES=[

    {

        value:"credit_card",

        label:"Credit Card"

    },

    {

        value:"personal",

        label:"Personal"

    },

    {

        value:"business",

        label:"Business"

    },

    {

        value:"lap",

        label:"LAP"

    },

    {

        value:"home",

        label:"Home"

    }

];